import { EFormaCp } from 'enums/isin/udaje/formaCp';

const formaCpSelect = [
    {
        value: EFormaCp._1,
        labelcz: 'ISIN_EMISE_AKCIE_FORMA_NADORUCITELE'
    },
    {
        value: EFormaCp._3,
        labelcz: 'ISIN_EMISE_AKCIE_FORMA_NAJMENO'
    },
    {
        value: EFormaCp._4,
        labelcz: 'ISIN_EMISE_AKCIE_FORMA_NEURCENO'
    }
];
export const formaCpSelectAkcie = [
    {
        value: EFormaCp._1,
        labelcz: 'ISIN_EMISE_AKCIE_FORMA_NAMAJITELE'
    },
    {
        value: EFormaCp._3,
        labelcz: 'ISIN_EMISE_AKCIE_FORMA_NAJMENO'
    }
];

export default formaCpSelect;
